import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 20h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 10h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 14h2v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 4h2v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "4", height: "6", x: "6", y: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "4", height: "6", x: "14", y: "14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Binary";
const Binary = memo(themed(Icon));
export {
  Binary
};
//# sourceMappingURL=binary.js.map
